<template>
  <body>
    <aside class="Blk-1">
      <img class="imagen" :src="usuarioVista.foto">
    </aside>
    <aside class="Blk-2">
      <article class="Form">
        <div class="Blk-Campo">
          <p id="titReg">Usuarios registrados</p>
          <select name="usuarios" id="" class="campo"
            :disabled = 'habBotAndCamp.hab'
            v-model="usuarioSel" @change.prevent="mostrarDatosUsuario(usuarioSel._id)">
            <option v-for="usuario in listaUsuarios"
              :key="usuario._id"
              :value="usuario">
              {{usuario.apellidos}},  {{usuario.nombre}}
            </option>
          </select>
        </div>
        <form @change="cambioForm">
          <div class="Blk-Campo">
            <p>Nombre*</p>
            <input name="titulo" class="campo" ref="nombreUsuario" rows="2"
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="usuarioVista.nombre"
              spellcheck="false"
            >
          </div>
          <div class="Blk-Campo">
            <p>Apellidos</p>
            <input type="text" name="apellidos" class="campo"
              v-model.trim="usuarioVista.apellidos"
              :disabled = '!habBotAndCamp.hab'
              spellcheck="false"
            >
          </div>
           <div class="Blk-Campo">
            <p>e-Mail</p>
            <input type="text" name="email" class="campo"
              v-model.trim="usuarioVista.email"
              :disabled = '!habBotAndCamp.hab'
              spellcheck="false"
            >
          </div>
          <div class="Blk-Campo">
            <p>País</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="usuarioVista.pais"
              :disabled = '!habBotAndCamp.hab'
              spellcheck="false"
            >
          </div><div class="Blk-Campo">
            <p>Visitas</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="usuarioVista.visitas"
              :disabled = true
              spellcheck="false"
            >
          <div class="Blk-Campo">
            <p>Fecha registro</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="usuarioVista.fechaReg"
              :disabled = true
              spellcheck="false"
            >
          <div class="Blk-Campo">
            <p>Última visita</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="usuarioVista.lastVisit"
              :disabled = true
              spellcheck="false"
            >
          </div>
          </div>
          </div>
          <div class="Blk-Campo">
            <div class="check">
              <p>Miembro SVE</p>
              <input type="checkbox" name="miembro"
                v-model.trim="miembro"
                :disabled = '!habBotAndCamp.hab'>
            </div>
            <div class="check">
              <p>Bibliotecario</p>
              <input type="checkbox" name="biblio"
                v-model.trim="biblio"
                :disabled = '!habBotAndCamp.hab'>
            </div>
          </div>
          <div class="BtnImg">
            <input type="file" name="file-1" id="file-1" class="inputfile"
            @change="cargarPortada" :disabled = '!habBotAndCamp.hab'/>
            <label for="file-1" ><span class="icon-icoSubirImg"></span></label>
            <p id="eti">Cargar foto</p>
          </div>
          <img class="imagen2" :src="usuarioVista.foto">
        </form>
      </article>
      <aside class="Btns">
        <BotonesCRUD
        :botones=[0,1,1,1]
        :desacMas= true
        :desacEdit="!habBotAndCamp.actEdi"
        :desacMenos="!habBotAndCamp.actMen"
        :desacSave="!habBotAndCamp.actSav"
        @editar="editar"
        @del="borrar"
        @save="save"
        />
      </aside>
    </aside>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import BotonesCRUD from '../components/BotonesCRUD.vue'
import axios from 'axios'
export default {
  name: 'FormUsuarios',
  components: { BotonesCRUD },
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.getListaUsuarios() // Trae lista de nombres de usuarios sin otros datos
    this.activaModo('INI')
  },
  data () {
    return {
      usuarioSel: {},
      usuarioSelBkUp: [],
      listaUsuarios: [],
      usuarioVista: {},
      usuarioVistaBkUp: {},
      habBotAndCamp: {
        actMas: false,
        actEdi: false,
        actMen: false,
        actSav: false,
        hab: false
      },
      IsModoSalirMas: false,
      IsModoSalirEdi: false,
      miembro: false,
      biblio: false,
      admin: false,
      URLbase: '',
      token: ''
    }
  },
  methods: {
    async getListaUsuarios () {
      try {
        const url = `${this.URLbase}/users/listUsers`
        const res = await fetch(url)
        this.listaUsuarios = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    mostrarDatosUsuario (IdUsuario) {
      this.getDatosUsuario(IdUsuario)
      this.activaModo('S')
    },
    getDatosUsuario (IdSelecc) {
      try {
        const url = `${this.URLbase}/users/getUserData`
        const userId = { _id: IdSelecc }
        console.log('id de usuario:' + userId)
        axios.post(url, userId)
          .then(result => {
            const datosUsuario = result.data
            this.usuarioVista = datosUsuario
            switch (this.usuarioVista.tipoUsuario) {
              case 0 :
                this.miembro = false
                this.biblio = false
                break
              case 1 :
                this.miembro = true
                this.biblio = false
                break
              case 2 :
                this.miembro = true
                this.biblio = true
                break
              case 3 :
                this.miembro = true
                this.biblio = true
                this.admin = true
                break
            }
          })
          .catch(error => console.log(error))
      } catch (error) {
        alert(error)
      }
    },
    editar () {
      this.IsModoSalirEdi = !this.IsModoSalirEdi
      // Si es modo edición, hace copia de los datos actuales por si se cancela
      if (this.IsModoSalirEdi) {
        this.usuarioVistaBkUp = JSON.parse(JSON.stringify(this.usuarioVista))
        this.usuarioSelBkUp = this.usuarioSel
        this.activaModo('EDI')
      } else {
        // Si se cancela, resatura los valores previos
        this.usuarioVista = JSON.parse(JSON.stringify(this.usuarioVistaBkUp))
        this.usuarioSel = this.usuarioSelBkUp
        this.activaModo('S')
      }
    },
    cambioForm () {
      if (this.IsModoSalirMas) {
        this.activaModo('MASs')
      }
      if (this.IsModoSalirEdi) {
        this.activaModo('EDIs')
      }
    },
    async borrar () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de este usuario. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C'
      )
      if (response === 'borrar') {
        try {
          const url = `${this.URLbase}/users/borrarUsuario`
          const usuarioId = { _id: this.usuarioSel._id }
          axios.post(url, usuarioId, {
            headers: {
              authorization: this.token
            }
          })
            .then(result => {
              switch (result.status) {
                case 200:
                  this.blanquearUsuarioVista()
                  this.alertJoa('¡Registro borrado con éxito!', 'S')
                  this.getListaUsuarios()
                  this.activaModo('INI')
                  break
                case 500:
                  this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
                  break
                default:
                  this.alertJoa('Algo salió mal, intenta otra vez', 'E')
              }
            })
            .catch(error => {
              console.log(error)
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
            })
        } catch (error) {
          alert(error)
        }
      }
    },
    async save () {
      // Primero hay que transformar los datos lógicos miembro y biblio en tipo usuario
      if (this.miembro === false && this.biblio === false) {
        this.usuarioVista.tipoUsuario = 0
      } else {
        if (this.miembro === true && this.biblio === false) {
          this.usuarioVista.tipoUsuario = 1
        } else { this.usuarioVista.tipoUsuario = 2 }
      }
      // Luego se envía un POST con axios a la url de saveUserGest con el json de los datos

      try {
        const url = `${this.URLbase}/users/saveUserGest`
        const userData = this.usuarioVista
        axios.post(url, userData, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error en la actualización, reinicia la aplicación e intenta otra vez', 'E')
                break
              case 'success':
                this.alertJoa('Datos actualizados con éxito!', 'S')
                break
            }
          })
          .catch(error => console.log(error))
      } catch (error) {
        alert(error)
      }
      this.getListaUsuarios()
      this.IsModoSalirMas = false
      this.IsModoSalirEdi = false
      this.blanquearUsuarioVista()
      this.activaModo('INI')
    },
    blanquearUsuarioVista () {
      this.usuarioSel = []
      this.usuarioVista = {
        nombre: '',
        apellidos: '',
        email: '',
        pais: '',
        visitas: '',
        foto: ''
      }
      this.miembro = false
      this.biblio = false
    },
    cargarPortada (event) {
      // Asignamos la imagen a nuestra data
      const portada = event.target.files[0]
      // Si imagen > 500kB alertamos y salimos
      const tamaño = portada.size
      if (tamaño > 500000) {
        alert('El tamaño del archivo es: ' +
        Math.round(tamaño / 1000) +
        'kb. Por favor, selecciona un archivo de un tamaño menor a 500 kb')
      } else {
        // Cargamos la previsualización
        const reader = new FileReader()
        reader.readAsDataURL(portada)
        reader.onload = e => { this.usuarioVista.foto = e.target.result }
      }
    },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0]
          break
        case 'S':
          this.confModo = [1, 1, 1, 0, 0]
          break
        case 'MAS':
          this.confModo = [1, 0, 0, 0, 1]
          break
        case 'MASs':
          this.confModo = [1, 0, 0, 1, 1]
          break
        case 'EDI':
          this.confModo = [0, 1, 0, 0, 1]
          break
        case 'EDIs':
          this.confModo = [0, 1, 0, 1, 1]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    }
  },
  computed: {
    ...mapState(['usuarioEnSesion'])
  }
}

</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
.imagen{
  margin-top: 75px;
  width:80%;
  justify-self: center;
  box-shadow: rgb(53, 52, 52) 5px 5px 7px;
}
.imagen2{
  display:none;
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1.5%;
}
article.Form {
  /* color: darkslategray; */
  padding-top: 20px;
}
.Btns {
  /* display: grid; */
  padding-left: 20px;
  padding-top: 20px;
  /*position: sticky;  no funciona */
}
.formInd{
  margin-top: 55px;
}
.formIndTel{
  display:none;
}
.Blk-Campo{
  width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: var(--bo-cam);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: var(--az-ico);
}
.check{
  display: flex;
  margin-top: 2%;
}
.check p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  padding-right: 4px;
  max-width: 150px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
}
#titReg{
  font-weight: bold;
}

.BtnImg{
  display:flex;
  align-items: center;
}
.BtnImg p{
  color:black;
  font-size: 13px;
  padding-top: 4px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: relative;
  /* z-index: -1; *****/
  visibility:hidden;
}
/*Esta clase da el formato al boton y la etiqueta */
.inputfile + label {
  /* width: 63.5%;  */
  cursor: pointer;
  padding: 5px;
  text-align: left;
  margin-bottom: 6px;
  margin-top: 6px;
  color: black;
  font-size: 16px;
}
.inputfile + label:hover {
  transform: scale(1.08);
  /* background-color: rgb(192, 205, 206); */
  /* .inputfile:focus + label, .inputfile.has-focus + label,*/
}
.inputfile:disabled + label {
  color: #8fa3ad;
}
.icon-icoSubirImg {
  color: var(--az-ico);
  font-size: 1.45em;
  padding-left: 9px;
  padding-right: 9px;
}
input[type=checkbox] {
  transform: scale(1.2);
}
@media screen and (max-width: 600px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .Form {
    padding-top: 10px;
    overflow: scroll;
  }
  .Blk-Campo {
    flex-direction: column;
    /* align-items:flex-start; */
    align-items:stretch;
  }
  .Blk-Campo p{
    max-width: 190px;
    margin-left:1%;
  }
  .campo{
    /* width: 100% no funciona, el ancho se controla con align-items: strech en .Blk-Campo*/
    margin: 0 4% 0 4%;
  }
  .check{
    width: 43%;
    justify-content:flex-start;
    margin-top: 6px;
    /* border: solid 1px orange; */
  }
  aside.Btns {
    padding: 0 2.5% 2% 2.5%;
    /* background-color: var(--gr-fo-for); */
  }
  .formInd{
    display: none;
  }
  .formIndTel{
    display: block;
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
  .botonesAut{
    align-self: flex-end;
    margin-right: 2.5%;
  }
  .imagen2{
    display:inline-flex;
    width: 65%;
    margin-top: 5px;
    margin-bottom:15px;
    justify-self: center;
    box-shadow: rgb(53, 52, 52) 5px 5px 7px;
  }

}
</style>
